export class BookingCartCreationFailedException extends Error {
    constructor(message, content){
        super(message)
        this.name = 'BookingCartCreationFailedException'
        this.content = content
    }
}